// extracted by mini-css-extract-plugin
export default {"container":"gu-z","ratingLayout":"hu-z","ratingLabel":"iu-z","nonInteractiveRatingLabel":"ju-z"};